module.exports = __webpack_public_path__ + "img/icon2.ccfec142.png";